import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function Contact() {
  const [form, setForm] = useState({ name: '', email: '', phone: '', subject: '', message: '' });
  const [status, setStatus] = useState<'idle' | 'sending' | 'success' | 'error'>('idle');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (form.message.length > 500) {
      alert('Message cannot exceed 500 characters.');
      return;
    }
    setStatus('sending');
    try {
      const body = new URLSearchParams({
        name: form.name,
        email: form.email,
        phone: form.phone,
        subject: form.subject,
        message: form.message,
      });
      await fetch('https://readdy.ai/api/form/d70r5cf9hgr6oot2r4r0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });
      setStatus('success');
      setForm({ name: '', email: '', phone: '', subject: '', message: '' });
    } catch {
      setStatus('error');
    }
  };

  const contactInfo = [
    { icon: 'ri-map-pin-line', label: 'Address', value: '271 Rue Duvernay, Beloeil, QC J3G 2M3', color: '#F5B730' },
    { icon: 'ri-phone-line', label: 'Phone', value: '+1 (555) 012-3456', color: '#3DBD8A' },
    { icon: 'ri-printer-line', label: 'Fax', value: '+1 (555) 012-3457', color: '#8A6FD8' },
    { icon: 'ri-mail-line', label: 'Email', value: 'hello@littleloop.com', color: '#F5B730' },
    { icon: 'ri-time-line', label: 'Hours', value: 'Mon–Fri 10am–7pm · Sat–Sun 10am–5pm', color: '#3DBD8A' },
  ];

  return (
    <div style={{ fontFamily: "'Nunito', sans-serif" }}>
      <Navbar />

      <section className="pt-28 pb-10" style={{ backgroundColor: '#F5F2FD' }}>
        <div className="max-w-7xl mx-auto px-6">
          <span className="text-brand-purple text-xs font-600 uppercase tracking-widest" style={{ fontWeight: 600 }}>We&apos;re here for you</span>
          <h1 className="text-4xl font-700 text-gray-800 mt-2" style={{ fontFamily: "'Quicksand', sans-serif", fontWeight: 700 }}>
            Get in Touch
          </h1>
          <p className="text-gray-500 text-sm mt-2">Write us, visit us, or give us a call. We&apos;re always available.</p>
        </div>
      </section>

      <section className="py-14">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex flex-col lg:flex-row gap-12">
            <div className="flex-1">
              <div className="bg-white rounded-3xl p-8">
                <h2 className="text-xl font-700 text-gray-800 mb-6" style={{ fontFamily: "'Quicksand', sans-serif", fontWeight: 700 }}>
                  Send Us a Message
                </h2>

                {status === 'success' ? (
                  <div className="text-center py-10">
                    <div className="flex items-center justify-center w-16 h-16 bg-green-100 rounded-full mx-auto mb-4">
                      <i className="ri-check-double-line text-green-600 text-3xl"></i>
                    </div>
                    <p className="font-700 text-gray-800 text-lg mb-2" style={{ fontFamily: "'Quicksand', sans-serif", fontWeight: 700 }}>
                      Message Sent!
                    </p>
                    <p className="text-gray-500 text-sm">We&apos;ll get back to you soon. Thanks for reaching out!</p>
                    <button
                      onClick={() => setStatus('idle')}
                      className="mt-6 px-6 py-2.5 bg-brand-yellow text-white rounded-full text-sm font-600 cursor-pointer hover:bg-brand-yellow-dark transition-colors whitespace-nowrap"
                      style={{ fontWeight: 600 }}
                    >
                      Send another message
                    </button>
                  </div>
                ) : (
                  <form onSubmit={handleSubmit} data-readdy-form className="space-y-4">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div>
                        <label className="block text-xs text-gray-500 mb-1 font-600" style={{ fontWeight: 600 }}>Full Name *</label>
                        <input name="name" value={form.name} onChange={handleChange} required placeholder="Your full name" className="w-full border border-gray-200 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-brand-yellow bg-gray-50" />
                      </div>
                      <div>
                        <label className="block text-xs text-gray-500 mb-1 font-600" style={{ fontWeight: 600 }}>Email *</label>
                        <input type="email" name="email" value={form.email} onChange={handleChange} required placeholder="your@email.com" className="w-full border border-gray-200 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-brand-yellow bg-gray-50" />
                      </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div>
                        <label className="block text-xs text-gray-500 mb-1 font-600" style={{ fontWeight: 600 }}>Phone</label>
                        <input name="phone" value={form.phone} onChange={handleChange} placeholder="+1 (555) 000-0000" className="w-full border border-gray-200 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-brand-yellow bg-gray-50" />
                      </div>
                      <div>
                        <label className="block text-xs text-gray-500 mb-1 font-600" style={{ fontWeight: 600 }}>Subject *</label>
                        <select name="subject" value={form.subject} onChange={handleChange} required className="w-full border border-gray-200 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-brand-yellow bg-gray-50 cursor-pointer">
                          <option value="">Select a subject</option>
                          <option value="Product inquiry">Product inquiry</option>
                          <option value="Clothing donation">Clothing donation</option>
                          <option value="Orders and shipping">Orders and shipping</option>
                          <option value="Return request">Return request</option>
                          <option value="Other">Other</option>
                        </select>
                      </div>
                    </div>

                    <div>
                      <label className="block text-xs text-gray-500 mb-1 font-600" style={{ fontWeight: 600 }}>
                        Message * <span className="font-400 text-gray-400">(max 500 characters)</span>
                      </label>
                      <textarea
                        name="message"
                        value={form.message}
                        onChange={handleChange}
                        required
                        maxLength={500}
                        rows={4}
                        placeholder="How can we help you?"
                        className="w-full border border-gray-200 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-brand-yellow bg-gray-50 resize-none"
                      />
                      <p className="text-xs text-gray-400 mt-1 text-right">{form.message.length}/500</p>
                    </div>

                    {status === 'error' && <p className="text-sm text-red-500">Something went wrong. Please try again.</p>}

                    <button
                      type="submit"
                      disabled={status === 'sending'}
                      className="w-full py-3.5 bg-brand-yellow text-white rounded-full font-600 hover:bg-brand-yellow-dark transition-colors cursor-pointer whitespace-nowrap disabled:opacity-60"
                      style={{ fontWeight: 600 }}
                    >
                      {status === 'sending' ? 'Sending...' : 'Send Message'}
                    </button>
                  </form>
                )}
              </div>
            </div>

            <div className="lg:w-96">
              <div className="bg-white rounded-3xl p-8 mb-6">
                <h2 className="text-xl font-700 text-gray-800 mb-6" style={{ fontFamily: "'Quicksand', sans-serif", fontWeight: 700 }}>
                  Contact Information
                </h2>
                <div className="space-y-5">
                  {contactInfo.map(info => (
                    <div key={info.label} className="flex items-start gap-3">
                      <div className="flex items-center justify-center w-9 h-9 rounded-xl flex-shrink-0" style={{ backgroundColor: info.color + '22' }}>
                        <i className={`${info.icon}`} style={{ color: info.color }}></i>
                      </div>
                      <div>
                        <p className="text-xs text-gray-400 mb-0.5">{info.label}</p>
                        <p className="text-sm font-600 text-gray-700" style={{ fontWeight: 600 }}>{info.value}</p>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="flex items-center gap-3 mt-8 pt-6 border-t border-gray-100">
                  <a href="#" rel="nofollow" className="flex items-center justify-center w-10 h-10 rounded-full bg-brand-purple-light text-brand-purple hover:bg-brand-purple hover:text-white transition-colors cursor-pointer">
                    <i className="ri-instagram-line text-lg"></i>
                  </a>
                  <a href="#" rel="nofollow" className="flex items-center justify-center w-10 h-10 rounded-full bg-brand-purple-light text-brand-purple hover:bg-brand-purple hover:text-white transition-colors cursor-pointer">
                    <i className="ri-facebook-line text-lg"></i>
                  </a>
                </div>
              </div>
              <div className="rounded-3xl overflow-hidden" style={{ height: '200px' }}>
                <iframe
                  src="https://www.google.com/maps?q=271+Rue+Duvernay,+Beloeil,+QC+J3G+2M3&output=embed"
                  width="100%"
                  height="200"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Little Loop location map"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
